import { css } from 'linaria';

export const root = css`
  margin-top: var(--space-200);
`;

export const titleWrapper = css`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
`;

export const productReturns = css`
  display: flex;
  flex-direction: row;
  gap: var(--space-200);
  margin: var(--space-250) 0 var(--space-100) 0;
`;

export const textContainer = css`
  margin-top: var(--space-100);
`;

export const plusButton = css`
  width: var(--space-300);
  height: var(--space-300);
`;
